import React from 'react';

export const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-white py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl font-extrabold text-black mb-8">Privacy Policy</h1>
        
        <div className="space-y-8 text-black">
          <section>
            <h2 className="text-2xl font-bold text-black mb-4">Introduction</h2>
            <p className="mb-4">
              At RigidAthlete, we take your privacy seriously. This Privacy Policy explains how we collect,
              use, disclose, and protect your information when you use our website and services.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-black mb-4">Information We Collect</h2>
            <h3 className="text-xl font-semibold mb-2">Personal Information</h3>
            <ul className="list-disc pl-6 mb-4">
              <li>Name and contact details</li>
              <li>Age, height, and weight</li>
              <li>Fitness goals and preferences</li>
              <li>Exercise and nutrition history</li>
              <li>Payment information</li>
            </ul>

            <h3 className="text-xl font-semibold mb-2">Usage Information</h3>
            <ul className="list-disc pl-6 mb-4">
              <li>Device and browser information</li>
              <li>IP address and location data</li>
              <li>Usage habits and preferences</li>
              <li>Communication preferences</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-black mb-4">How We Use Your Information</h2>
            <ul className="list-disc pl-6">
              <li>To provide and personalize our services</li>
              <li>To improve our platform and user experience</li>
              <li>To communicate with you regarding your account and updates</li>
              <li>To process payments and manage billing information</li>
              <li>To comply with our legal obligations</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-black mb-4">Data Security</h2>
            <p className="mb-4">
              We implement appropriate technical and organizational security measures to protect your
              personal information against unauthorized access, disclosure, modification, or destruction.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-black mb-4">Your Rights</h2>
            <p className="mb-4">You have the right to:</p>
            <ul className="list-disc pl-6">
              <li>Access your personal information</li>
              <li>Correct inaccurate information</li>
              <li>Request deletion of your information</li>
              <li>Unsubscribe from marketing communications</li>
              <li>File a complaint with supervisory authorities</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-black mb-4">Cookies and Tracking</h2>
            <p className="mb-4">
              We use cookies and similar tracking technologies to enhance your browsing experience,
              analyze site traffic, and understand where our visitors come from.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-black mb-4">Contact Us</h2>
            <p>
              If you have any questions about this Privacy Policy or our practices, contact us at:
              <br />
              Email: privacy@rigidathlete.com
              <br />
              Address: [Company Address]
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-black mb-4">Updates to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. We will notify you of any changes by
              posting the new Privacy Policy on this page and updating the "Last Updated" date.
            </p>
            <p className="mt-4 font-semibold">Last Updated: [Current Date]</p>
          </section>
        </div>
      </div>
    </div>
  );
};
